/**
 * Converts friendly key names to physical key codes.
 * Used when usePhysicalKeys is true.
 */

export function friendlyKeyNameToPhysicalKeyCode(key: string): string {
  const lower = key.toLowerCase();

  // Single letters → KeyA, KeyB, etc.
  if (lower.length === 1 && /[a-z]/.test(lower)) {
    return `Key${lower.toUpperCase()}`;
  }

  // Numbers → Digit0, Digit1, etc.
  if (/^[0-9]$/.test(lower)) {
    return `Digit${lower}`;
  }

  // Special keys and punctuation
  switch (lower) {
    // Modifiers (multiple variations)
    case 'meta':
    case 'cmd':
    case 'command':
      return 'MetaLeft';
    case 'ctrl':
    case 'control':
      return 'ControlLeft';
    case 'shift':
      return 'ShiftLeft';
    case 'alt':
    case 'option':
      return 'AltLeft';

    // Special keys
    case 'escape':
    case 'esc':
      return 'Escape';
    case 'enter':
    case 'return':
      return 'Enter';
    case 'space':
    case ' ':
      return 'Space';
    case 'tab':
      return 'Tab';
    case 'backspace':
      return 'Backspace';
    case 'delete':
    case 'del':
      return 'Delete';
    case 'up':
    case 'arrowup':
      return 'ArrowUp';
    case 'down':
    case 'arrowdown':
      return 'ArrowDown';
    case 'left':
    case 'arrowleft':
      return 'ArrowLeft';
    case 'right':
    case 'arrowright':
      return 'ArrowRight';

    // Punctuation (handles both shifted and unshifted)
    case '/':
    case '?':
      return 'Slash';
    case '.':
    case '>':
      return 'Period';
    case ',':
    case '<':
      return 'Comma';
    case ';':
    case ':':
      return 'Semicolon';
    case "'":
    case '"':
      return 'Quote';
    case '[':
    case '{':
      return 'BracketLeft';
    case ']':
    case '}':
      return 'BracketRight';
    case '\\':
    case '|':
      return 'Backslash';
    case '-':
    case '_':
      return 'Minus';
    case '=':
    case '+':
      return 'Equal';
    case '`':
    case '~':
      return 'Backquote';

    default:
      // Pass through unknown keys
      return key;
  }
}
